export default __webpack_public_path__ + "static/media/Manila-Water.f225aa82.png";